var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useEffect } from "react";
import { getFilters, updateFilters } from "../providers/FilterProvider";
import { FilterRestrictionContext, } from "../providers/FilterRestrictionProvider";
import { filterNameMapping } from "../store/api/core";
export var restrictionKeyMap = filterNameMapping;
var restrictionsToString = function (restrictions) {
    return JSON.stringify(Object.entries(restrictions).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, Array.from(value)];
    }));
};
var countRestrictions = function (restrictions) {
    return Object.values(restrictions).reduce(function (current, set) { return current + set.size; }, 0);
};
export var useRestrictionSetup = function (filtersIn) {
    var _a = useContext(FilterRestrictionContext), restrictions = _a.restrictions, setRestrictions = _a.setRestrictions;
    useEffect(function () {
        if (!filtersIn) {
            return;
        }
        var filters = getFilters();
        var given = Object.entries(filtersIn || {}).reduce(function (current, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, current), (_b = {}, _b[key] = new Set(value || []), _b)));
        }, {});
        if (!(countRestrictions(restrictions) == 0 && countRestrictions(given) == 0) &&
            restrictionsToString(restrictions) != restrictionsToString(given)) {
            setRestrictions(given);
        }
        if (!areFiltersRestricted(given, filters)) {
            updateFilters(Object.entries(given).reduce(function (current, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (__assign(__assign({}, current), (_b = {}, _b[key] = Array.from(value || []), _b)));
            }, filters));
        }
    }, [JSON.stringify(filtersIn)]);
};
var areFiltersRestricted = function (restrictions, filters) {
    for (var _i = 0, _a = Object.entries(restrictions || {}); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], restrictionSetIn = _b[1];
        var filterValues = (filters === null || filters === void 0 ? void 0 : filters[key]) || [];
        var restrictionSet = restrictionSetIn || new Set();
        if (filterValues.length != restrictionSet.size) {
            return false;
        }
        for (var _c = 0, filterValues_1 = filterValues; _c < filterValues_1.length; _c++) {
            var value = filterValues_1[_c];
            if (!restrictionSet.has(value)) {
                return false;
            }
        }
    }
    return true;
};
